<template>
	<v-card variant="tonal" color="primary" class="pa-2">
		<v-card-text>
			<h3 class="text-h6 mb-1">Try it now</h3>
			<p class="text-medium-emphasis mb-4">
				Paste a SHA-256 hash to check whether it exists in our database. Rate limited to {{ rateLimit }} checks/min.
			</p>

			<form @submit.prevent="submit">
				<v-text-field v-model="form.hash" label="SHA-256 hash" placeholder="e.g. 3f786850e387550fdab836ed7e6dc881de23001b..."
					density="compact" variant="outlined" :error-messages="form.errors.hash" clearable></v-text-field>

				<v-btn type="submit" color="primary" prepend-icon="mdi-magnify" :loading="form.processing">
					{{ $user ? 'Check hash' : 'Login to check' }}
				</v-btn>
			</form>

			<v-alert v-if="result" :type="result.exists ? 'success' : 'warning'" variant="tonal" class="mt-4">
				<template v-if="result.exists && result.phone_number">
					Found: <strong>{{ result.phone_number }}</strong>
				</template>
				<template v-else-if="result.exists">
					This hash exists in our database.
					<div class="text-caption mt-1">Generate an API token from your dashboard to resolve the phone number.</div>
				</template>
				<template v-else>
					No match found for this hash.
				</template>
			</v-alert>
		</v-card-text>
	</v-card>
</template>

<script setup>
	import { computed } from 'vue'
	import { router, useForm, usePage } from '@inertiajs/vue3'

	defineProps({
		rateLimit: Number,
	})

	const page = usePage()

	const form = useForm({
		hash: '',
	})

	const result = computed(() => page.props.hashCheckResult)

	function submit() {
		if (!page.props.auth.user) {
			router.visit(route('login'))
			return
		}

		form.post(route('hash-check'), {
			preserveScroll: true,
		})
	}
</script>
